import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()((theme) => {
    return {
        root: {
            backgroundColor: theme.palette.secondary[50],
            cursor: 'default',
        },
        gridWrapper: {
            padding: theme.spacing(1),
            display: 'flex',
            flexDirection: 'column',
            gap: theme.spacing(1),
        },
        isGenericAccount: {
            paddingBottom: theme.spacing(0.5),
        },
    }
})

export default useStyles
